import { cn } from "@/shared/lib/utils"
import * as React from "react"
import type { ElementType } from "react"

type TypographyProps = {
  variant: Variant
  as?: ElementType
} & React.HTMLAttributes<HTMLElement>

const tagMap: Record<Variant, ElementType> = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  h7: "p",
  h8: "p",
  caption: "span",
  regular: "p",
  "body-medium": "p",
  "body-small": "p",
  "body-Xsmall": "p",
}

const variants = {
  h1: "text-4xl leading-[44px] font-medium",
  h2: "text-[28px] leading-10 font-medium",
  h3: "text-2xl font-medium leading-[34px]",
  h4: "text-xl leading-[30px] font-medium",
  h5: "text-4xl font-extrabold",
  h6: "text-base leading-6 font-medium",
  h7: "text-sm leading-5 font-medium",
  h8: "text-xs leading-[18px] font-normal",
  caption: "text-xs leading-4 font-medium text-label-secondary",
  regular: "text-sm leading-5",
  "body-medium": "font-medium text-base leading-6 tracking-[-0.03em]",
  "body-small": "text-sm leading-5 font-normal tracking-[-0.03em] align-middle",
  "body-Xsmall":
    "text-xs leading-[18px] font-normal tracking-normal align-middle text-label-secondary",
} as const

type Variant = keyof typeof variants

export function Typography({
  variant,
  as,
  className,
  ...props
}: TypographyProps & { variant: Variant }) {
  const Tag = as ?? tagMap[variant]
  return <Tag className={cn(variants[variant], className)} {...props} />
}
